import { call, put, takeLatest } from 'redux-saga/effects';
import {
    GET_MY_TASKS_REQUEST,
    getMyTasksSuccess,
    getMyTasksFail,
    MARK_TASK_COMPLETED_REQUEST,
    markTaskCompletedSuccess,
    markTaskCompletedFail
} from '../actions/taskActions';
import {taskApi} from "../../../api";

function* getMyTasks(action) {
    try {
        const token = sessionStorage.getItem('token');
        const response = yield call(taskApi.getMyTasks, {
            userId: action.payload.userId,
            roleId: action.payload.roleId,
            token
        });
        yield put(getMyTasksSuccess(response.data));
    } catch (error) {
        yield put(getMyTasksFail(error.message));
    }
}

function* markTaskCompleted(action) {
    try {
        const token = sessionStorage.getItem('token');
        yield call(taskApi.markCompleted, {
            id: action.payload.taskId,
            token
        });
        yield put(markTaskCompletedSuccess(action.payload.taskId));
    } catch (error) {
        yield put(markTaskCompletedFail(error.message));
    }
}

export default function* taskSaga() {
    yield takeLatest(GET_MY_TASKS_REQUEST, getMyTasks);
    yield takeLatest(MARK_TASK_COMPLETED_REQUEST, markTaskCompleted);
}
